<template lang="pug">
section
  div
    | The online form asks you
    | for an estimate of the number
    | of Certificates of Sponsorship (CoS)
    | you may wish to assign in your first year,
    | you must be able to justify your request.
    | You will also need to understand the difference
    | between ‘defined’ and ‘undefined’ CoS
    | while applying under ‘Skilled Worker’ route:

  ul
    li
      b ‘Undefined’
      |
      | CoS:
      | for workers who will be applying
      | for permission to remain in the UK
      | (e.g. they already live in the UK
      | and will be ‘switching’ their visa);
    li
      b ‘Defined’
      |
      | CoS:
      | for workers who are outside the UK
      | and will be applying for entry clearance.

  br

  div
    b
      | Candidate has been identified
      | (lives in the UK
      | and will be ‘switching’ their visa)

  div
    | You can submit the number of
    |
    b ‘undefined’ CoS
    |
    | as part of your licence application,
    | it is recommended that you ask
    | for ONE ‘undefined’ CoS initially
    | (even though you might need
    | to sponsor several skilled workers),
    | and you can later increase
    | the allocation of CoS
    | via Sponsor Management System
    | once your licence is granted.

  div
    | You will be required
    | to provide additional information
    | about current vacancies
    | and workers you wish to sponsor.

  br

  div
    b
      | Candidate has been identified
      | (lives outside of the UK)

  div
    | You cannot request an allocation of
    |
    b ‘defined’ CoS
    |
    | as part of your licence application
    | (you must put NIL in the form).
    | However, you still might mention
    | that you identified a candidate
    | in your Cover Letter,
    | and you will request allocation of ‘defined’ CoS
    | via SMS once your licence is granted.
    | By this you will demonstrate to the Home Office
    | that you understand the process of CoS allocation
    | and what it is required from you as a sponsor.

  br

  div
    b
      | No candidate

  div
    | If you are still in the process
    | of identifying a suitable candidate
    | and wish to become a sponsor
    | in case you decide
    | to sponsor a skilled worker,
    | you must put NIL in the form.
    | Later you can allocate ‘defined’
    | or ‘undefined’ CoS via SMS.
</template>

<script>
export default {
  name: "prepare_ao_cos",
};
</script>